import React from "react";
import { FaCloud, FaUsers, FaPlug, FaVial } from "react-icons/fa";
import imgSrc from "../../assests/760 copy.jpg";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import Slider from "react-slick";
// import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import '../../Style/Spamie.css';
import Carousel from 'react-multi-carousel';
import Cerner from '../../assests/Cerner2.png';
import Athena from '../../assests/athena 2.png';
import Epic from '../../assests/epic 2.png';
import Medi from '../../assests/medi2 2.png';
import Vista from '../../assests/vista2.png';
import Netsmart from '../../assests/Netsmart2.png';
import Drfirst from '../../assests/Drfirst2.png';
import Philips from '../../assests/Philips2.png';
import Dicom from '../../assests/Dicom2.png';
import Smile from '../../assests/SmileCDR 2.png';

const responsiveSettings = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1024 },
    items: 8
  },
  desktop: {
    breakpoint: { max: 1024, min: 768 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 768, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};
const cardVariants = {
  hover: { 
    scale: 1.1, 
    // boxShadow: "0px 20px 40px rgba(42, 98, 122, 0.6)", 
    transition: { duration: 0.3, ease: "easeOut" }
  },
};

export default function DigitalTransformation() {
  return (
    <div className="relative min-h-screen w-full p-8 text-white flex flex-col gap-12">

      {/* Full-Width Centered Heading & Paragraph */}
      <div className="w-full text-center">
        <h1 className="w-full text-center px-6 md:px-12 text-[15px] font-bold text-black 
                    bg-gradient-to-l from-[#2a627a] to-transparent bg-opacity-100 
                    backdrop-blur-lg p-4 rounded-lg shadow-lg transition-all duration-300">
          Integrating
          <span className="font-bold text-black text-lg ml-3">
            EMR/EHR
          </span>
        </h1>

        <p className="w-full max-w-2xl mx-auto text-sm text-black mt-3  leading-relaxed">
          At <span className="font-bold text-[#2a627a]">HIKEHEALTH GS</span>, we are shaping the future of healthcare through advanced digital transformation solutions.
          Our services help healthcare organizations streamline operations, enhance cybersecurity, and transition seamlessly to cloud-based infrastructures.
        </p>
      </div>
      {/* <div className="w-full flex justify-center items-center overflow-x-auto px-6 py-10">
      <div className="flex gap-8">
        {[Cerner, Athena, Epic, Medi, Vista, Netsmart].map((src, index) => (
          <motion.div
            key={index}
            variants={cardVariants}
            whileHover="hover"
            className="relative flex flex-col items-center backdrop-blur-3xl p-4 rounded-xl  border  hover:border-[#2a6270]/70 transition-all cursor-pointer"
            style={{ width: "120px", height: "120px" }} // ✅ **Fixed Size**
          >
           
            <div className="absolute inset-0 bg-gradient-to-t from-[#2a627a]/40 to-transparent rounded-xl opacity-50 transition-opacity duration-500 blur-md"></div>

            
            <img draggable={false}className="w-full h-full object-contain p-2" src={src} alt={`EMR/EHR-${index}`} />
          </motion.div>
        ))}
      </div>
    </div> */}


      {/* Carousel */}

      {/* <Carousel
        swipeable
        draggable={false}
        responsive={responsiveSettings}
        infinite
        autoPlay
        autoPlaySpeed={1000}
        keyBoardControl
        customTransition="all .5"
        transitionDuration={100}
        containerClass="carousel-container"
        removeArrowOnDeviceType={['tablet', 'mobile', ' superLargeDesktop', 'desktop']}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        className=" flex overflow-hidden shadow-md bg-gray-300  bg-opacity-70 rounded-2xl z-10"
      >
        {[Cerner, Athena, Epic, Medi, Vista, Netsmart, Drfirst, Dicom, Philips, Smile, Cerner, Athena, Epic, Medi, Vista, Netsmart, Drfirst, Dicom, Philips, Smile].map((src, index) => (
          <div key={index} className="m-4 flex flex-col lg:p-0  mt-0   md:h-30 lg:h-30  xl:h-30 items-center lg:flex-row w-[full]">
            <div className="mx-auto flex lg:gap-10 md:gap-10 w-full mt-10">
              <div className="text-center">
                <img draggable={false}className="mx-auto h-36 md:h-20 lg:h-30 p-2 rounded" src={src} alt={`tech-${index}`} />
              </div>
            </div>
          </div>
        ))}

      </Carousel> */}


      {/* Service Cards & Image Section */}
      <div className="w-full flex flex-col md:flex-row justify-center items-center gap-12">
        {/* Left Side - Service Cards */}
        <div className="w-full md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-xl">
            <ServiceCard
              title="Product Understanding "
              description="We analyze and understand the technical architecture or components of your healthcare product to ensure we align with your existing framework and needs."
              icon={<FaCloud className="text-[#2a627a] text-5xl" />}
            />
            <ServiceCard
              title="Team Allocation"
              description="Our experienced team is dedicated to your EMR/EHR integration project, ensuring that the right expertise is applied at every stage of the process."
              icon={<FaUsers className="text-[#2a627a] text-5xl" />}
            />
            <ServiceCard
              title="Integration"
              description="We execute seamless integration of healthcare systems while strictly adhering to interoperability standards, ensuring smooth data exchange across platforms."
              icon={<FaPlug className="text-[#2a627a] text-5xl" />}
            />
            <ServiceCard
              title="Pilot"
              description="Our team runs tests to ensure your product connects with EMR/EHR systems and supports real-time data exchange, ensuring that the integration meets operational requirements."
              icon={<FaVial className="text-[#2a627a] text-5xl" />}
            />
          </div>
        </div>

        {/* Right Side - Image */}
        <div className="w-full md:w-1/2 flex justify-center md:justify-end">
          <img
            src={imgSrc}
            alt="Digital Healthcare"
            className="w-full max-w-lg h-auto object-cover rounded-lg shadow-xl drop-shadow-2xl"
          />
        </div>
      </div>

    </div>



  )
}

// Service Card Component
const ServiceCard = ({ title, description, icon }) => (
  // <div className="bg-white bg-opacity-50 hover:bg-white text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl">
  <motion.div
    // className="relative z-10 bg-[#03ab3b] bg-opacity-70 hover:bg-[#03ab3b] group text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
    className="relative z-10 bg-gray-300 bg-opacity-70 hover:bg-gray-300 group text-gray-800 p-6 rounded-xl shadow-lg transition-transform transform hover:scale-105 hover:shadow-2xl"
    initial={{ opacity: 0, x: -100 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 1 }}
  > <div className="absolute inset-0 rounded-xl border-2 border-transparent hover:border-[#2a627a] transition-all duration-300"></div>
    <div className="flex items-center justify-center mb-4">{icon}</div>
    <h3 className="text-lg font-bold  text-center mb-2 text-[#2a627a]">{title}</h3>
    <p className="text-center text-sm  text-gray-800">{description}</p>
  </motion.div>

);
